import {ConnextraType} from "data/enums";

export const createConnextraScriptTag = (type: ConnextraType, params?: string) => {
	const elementName = "script";
	const SCRIPT_ID = "connextra-tagging";
	document.getElementById(SCRIPT_ID)?.remove();

	const script = document.createElement(elementName);
	script.id = SCRIPT_ID;

	script.src = {
		[ConnextraType.HOME_PAGE]:
			"https://zz.connextra.com/dcs/tagController/tag/8ce716f59752/f2p_pickem_homepage",
		[ConnextraType.PICK_CONFIRM]:
			"https://zz.connextra.com/dcs/tagController/tag/8ce716f59752/f2p_pickem_pickconfirm",
		[ConnextraType.SHARE_CLICK]:
			"https://zz.connextra.com/dcs/tagController/tag/8ce716f59752/f2p_pickem_shareclick",
		[ConnextraType.EMAIL_OPTIN]:
			"https://zz.connextra.com/dcs/tagController/tag/8ce716f59752/email_optin",
	}[type];

	if (params) {
		script.src += "?";
		script.src += params;
	}

	script.async = true;
	script.defer = true;

	const firstJS = document.getElementsByTagName(elementName)[0];
	firstJS.parentNode!.insertBefore(script, firstJS);

	return script;
};
